import script from "./CardPropertyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPropertyComponent.vue?vue&type=script&setup=true&lang=js"

import "./CardPropertyComponent.vue?vue&type=style&index=0&id=7c0e2f69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0e2f69"]])

export default __exports__